import ContactInfo from './ContactInfo/ContactInfo';
import ContactForm from './ContactForm/ContactForm';
import Title from '../Title/Title';
import Stores from '../Stores/Stores';

import store1 from '../../assets/images/store-1.jpg';
import store2 from '../../assets/images/store-2.jpg';
import store3 from '../../assets/images/store-3.jpg';
import store4 from '../../assets/images/store-4.jpg';

import { useTranslation } from 'react-i18next';

const ContactUs = () => {
  const { t } = useTranslation();
  return (
    <section className="py-5">
      <div className="container">
        <Title title={t('Contact.1')} />
        <div className="row">
          <div className="col-10 col-md-3 mx-auto">
            <ContactInfo />
          </div>
          <div className="col-10 col-md-9 mx-auto">
            <ContactForm />
          </div>
        </div>
        <div className="pt-5 pb-4">
          <Title title={t('Contact.2')} />
        </div>
        <div className="row">
          <div className="col-10 col-md-3 mx-auto">
            <Stores image={store4} title={t('Contact.15')}/>
          </div>
          <div className="col-10 col-md-3 mx-auto">
            <Stores image={store2} title={t('Contact.16')} />
          </div>
          <div className="col-10 col-md-3 mx-auto">
            <Stores image={store3} title={t('Contact.17')}/>
          </div>
          <div className="col-10 col-md-3 mx-auto">
            <Stores image={store1} title={t('Contact.18')} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
